import React from "react";
import { format, isToday, isThisYear, isThisMonth, sub, differenceInMinutes, differenceInHours } from "date-fns";

const isIn24Hours = (timestamp) => {
  const date = sub(new Date(timestamp), { hours: 9 });
  const now = new Date();
  const diffInMs = now - date;
  return diffInMs < 24 * 60 * 60 * 1000;
}

const TimestampDisplay = ({ timestamp }) => {
  const date = sub(new Date(timestamp), { hours: 9 });

  const now = new Date();
  const diffInMs = now - date;
  
  let formattedDate;
  if (diffInMs < 24 * 60 * 60 * 1000) { 
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    if (diffInMinutes < 60) {
      formattedDate = `${diffInMinutes}분 전`;
    } else {
      formattedDate = `${diffInHours}시간 전`;
    }
  } else if (isThisYear(date)) {
    formattedDate = format(date, "MM.dd");
  } else {
    formattedDate = format(date, "yyyy.MM.dd");
  }

  return <>{formattedDate}</>;
};

const TodayTimestampDisplay = ({ timestamp }) => {
  return <span className={isIn24Hours(timestamp) ? 'today' : ''}><TimestampDisplay timestamp={timestamp}/></span>;
};

export { TodayTimestampDisplay };
export default TimestampDisplay;